import React, { Fragment, ReactElement, useState } from 'react';
import { SearchFacet } from 'lib/searchspring/client';
import { useRouter } from 'next/router';
import FilterList from '@material-ui/icons/FilterList';
import Close from '@material-ui/icons/Close';
import MobileFilter from './MobileFilter';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import { SlideProps } from '@material-ui/core/Slide';

const useStyles = makeStyles({
  root: {
    width: '100vw',
    height: '100vh',
  },
});

const slideProps: Partial<SlideProps> = {
  onEnter: (node) => {
    node.style.transformOrigin = 'bottom';
    node.style.transform = 'scale(0.95)';
    node.style.opacity = '0';
  },
  onEntering: (node) => {
    node.style.transition = 'all 150ms ease-out';
    node.style.opacity = '1';
    node.style.transform = 'scale(1) ';
  },
  onExiting: (node) => {
    node.style.transition = 'all 150ms ease-in';
    node.style.opacity = '0';
    node.style.transform = 'scale(0.95)';
  },
};

export default function MobileFilters({ facets }: { facets: SearchFacet[] }): ReactElement {
  const [show, setShow] = useState(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const router = useRouter();
  const classes = useStyles();

  const panelChange = (panel: string) => (
    event: React.ChangeEvent<unknown>,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : false);
  };

  const hasSelected =
    facets.flatMap((facet) => facet.values.filter((value) => value.active)).length > 0;

  const clearAll = (): void => {
    const [url] = router.asPath.split('?');

    router.push(url);
    setShow(false);
    setExpanded(false);
  };

  const close = (): void => {
    setShow(false);
    setExpanded(false);
  };

  return (
    <>
      <button
        onClick={() => setShow(true)}
        aria-label="open filters"
        className={`flex md:hidden w-1/2 px-4 py-3 justify-between rounded focus:outline-none bg-white ${
          hasSelected ? 'has-selections' : 'border border-gray-400'
        }`}
      >
        Filter <FilterList />
      </button>

      <Drawer
        open={show}
        onEscapeKeyDown={() => setShow(false)}
        onClose={() => setShow(false)}
        transitionDuration={150}
        classes={{ paper: classes.root }}
        SlideProps={slideProps}
      >
        <div className="h-screen bg-white flex flex-col justify-between">
          {/* header section */}
          <div
            className="w-full bg-white p-4 flex justify-between items-center border-b"
            style={{ borderColor: '#BDBDBD' }}
          >
            <div className="font-bold">
              <FilterList /> Filters
            </div>
            <button aria-label="close filters" onClick={() => close()}>
              <Close style={{ fontSize: '30px' }} />
            </button>
          </div>

          {/* filter accordions */}
          <div className="p-4 flex flex-col flex-1 overflow-y-scroll">
            {facets.map((facet) => (
              <MobileFilter
                key={facet.label}
                facet={facet}
                panelChange={panelChange}
                expanded={expanded === facet.label}
              />
            ))}
          </div>

          {/* footer buttons */}
          <div
            className="px-4 py-5 flex justify-around bg-white w-screen mb-avoid-toolbar"
            style={{ boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)' }}
          >
            <button
              onClick={() => clearAll()}
              className="font-bold border border-black rounded-full py-3 px-10"
            >
              Clear All
            </button>
            <button
              onClick={() => close()}
              className="font-bold bg-highlight text-highlight rounded-full py-3 px-10"
            >
              Show Results
            </button>
          </div>
        </div>
      </Drawer>
    </>
  );
}
